import { dateFormat, dateFormatThai } from '@/configs/dateFormat';
import dayjs, { Dayjs } from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import ThaiBahtText from 'thai-baht-text';

dayjs.extend(buddhistEra);

const formatNumber = (
  value: number,
  degit?: number,
  minDegit?: number,
): string => {
  if (value === undefined || value === null) {
    return '0'; // Or handle as needed, e.g., return '';
  }
  const minDigits = minDegit ?? degit ?? 2;
  const maxDigits = Math.max(degit ?? 0, minDigits); // Ensure max is at least min

  return value.toLocaleString(undefined, {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  });
};

const formatDate = (
  date?: string | Date | Dayjs,
  format?: string,
  locale?: string,
): string => {
  return (
    (date &&
      dayjs(date || undefined)
        .locale(locale || 'th')
        .format(format || dateFormat)) ??
    ''
  );
};

/** Thai date with Buddhist Era year, e.g. 16/08/2569 */
const formatThaiDate = (
  date?: string | Date | Dayjs,
  format?: string,
): string => {
  return formatDate(date, format || dateFormatThai, 'th');
};

const convertNumberToThaiText = (number: number) => {
  return ThaiBahtText(number);
};

export { formatNumber, formatDate, formatThaiDate, convertNumberToThaiText };
